export default __webpack_public_path__ + "static/media/image4.16b84154.png";